import React, { useContext, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { MyContext } from "../../Context/MyContext";
import classes from "./BookACall.module.css";

const CALENDLY_SCRIPT = "https://assets.calendly.com/assets/external/widget.js";

const calendlyUrl = (theme) =>
  theme === "dark"
    ? "https://calendly.com/haroonabsar3/30min?hide_gdpr_banner=1&background_color=070b14&text_color=f4f7fb&primary_color=148af8"
    : "https://calendly.com/haroonabsar3/30min?hide_gdpr_banner=1&background_color=f7f9fc&text_color=0b1220&primary_color=148af8";

function mountWidget(container, url) {
  if (!container || !window.Calendly?.initInlineWidget) return;
  container.innerHTML = "";
  window.Calendly.initInlineWidget({
    url,
    parentElement: container,
  });
}

export default function BookACall() {
  const { appointmentRef, theme } = useContext(MyContext);
  const embedRef = useRef(null);

  useEffect(() => {
    const container = embedRef.current;
    const url = calendlyUrl(theme);

    if (window.Calendly?.initInlineWidget) {
      mountWidget(container, url);
      return undefined;
    }

    let script = document.querySelector(`script[src="${CALENDLY_SCRIPT}"]`);
    const onLoad = () => mountWidget(container, url);

    if (script) {
      script.addEventListener("load", onLoad);
      return () => script.removeEventListener("load", onLoad);
    }

    script = document.createElement("script");
    script.src = CALENDLY_SCRIPT;
    script.async = true;
    script.addEventListener("load", onLoad);
    document.body.appendChild(script);

    return () => script.removeEventListener("load", onLoad);
  }, [theme]);

  return (
    <section
      ref={appointmentRef}
      className={`sectionShell ${classes.section}`}
      id="book-appointment"
    >
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">Book a call</div>
          <h2 className="sectionTitle">Pick a time that works</h2>
          <p className="sectionLead">
            A 30-minute call to talk through what you need and the fastest way
            to ship it.
          </p>
          <a className={classes.email} href="mailto:admin@digitalination.com">
            admin@digitalination.com
          </a>
        </div>
        <div
          ref={embedRef}
          className={classes.embed}
          style={{ minWidth: "320px", height: "700px" }}
        />
      </Container>
    </section>
  );
}
